module.exports = __webpack_public_path__ + "img/plushederhover.f8c503f0.svg";